import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18149 Логировать адреса которые фреймят Облако
export const logUnknownFrameOrigins: boolean | undefined = getFeature('log-unk-frame-origins');
